import Animalia from './img/Animalia.png'
import Archaea from './img/Archaea.png'
import Under_Investigation from './img/Under Investigation.png'
import Protozoa from './img/Protozoa.png'
import Plantae from './img/Plantae.png'
import Fungi from './img/Fungi.png'
import Chromista from './img/Chromista.png'
import BacteriaImg from './img/Bacteria.png'

export const replaceThumbnails = {
    "Animalia": Animalia,
    "Archaea": Archaea,
    "Under Investigation": Under_Investigation,
    "Protozoa": Protozoa,
    "Plantae": Plantae,
    "Fungi": Fungi,
    "Chromista": Chromista,
    "Bacteria": BacteriaImg,
}